import { axiosClient } from '../axiosClient';
import { PresignedUrl } from './types';

type Params = {
  customerId: string;
  attributeName: string;
};

export const getCustomerAttributePresignedUrl = (params: Params) => {
  return axiosClient.get<PresignedUrl>(
    `/customers/${params.customerId}/attributes/${params.attributeName}/presigned-url`
  );
};
